//import history from 'history'
const history = require("history").createBrowserHistory

const customHistory = history();
export default customHistory;